var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Generic API service for external entity data
 */
import api from '@utils/axios';
/**
 * Fetches external entities from any API using configurable URL and field mapping
 * @param url - The API endpoint URL to fetch entities from
 * @param fieldMapping - Field mapping configuration for id and name fields
 * @returns Promise with array of external entities
 */
export function getExternalEntities(url_1) {
    return __awaiter(this, arguments, void 0, function* (url, fieldMapping = { idField: 'value', nameField: 'label' }) {
        try {
            const response = yield api.get(url);
            if (!Array.isArray(response.data)) {
                throw new Error(`Expected an array of entities from ${url} but received a non-array response`);
            }
            return response.data.map((entity) => {
                var _a;
                const rawId = entity[fieldMapping.idField];
                const id = /^\d+$/.test(rawId) ? Number(rawId) : rawId;
                const name = (_a = entity[fieldMapping.nameField]) !== null && _a !== void 0 ? _a : '';
                return Object.assign({ id,
                    name }, entity // Include all other fields from the original entity
                );
            });
        }
        catch (error) {
            console.error('Error fetching external entities:', error);
            throw error;
        }
    });
}
